import { http, bareHttp } from '@/core/api'
import { getAccessToken } from '@/core/auth/storage'

export type PushPlatform = 'android' | 'ios' | 'h5' | 'web'

export const pushApi = {
  register(payload: { token: string; platform: PushPlatform; device_id?: string; client_origin?: string }) {
    return http.post('/auth/push-token', payload)
  },

  /**
   * Prefer an explicit accessToken — logout clears storage before this request can run.
   */
  unregister(token: string, accessToken?: string | null) {
    const auth = accessToken ?? getAccessToken()
    return bareHttp.delete('/auth/push-token', {
      data: { token },
      headers: auth ? { Authorization: `Bearer ${auth}` } : undefined,
    })
  },
}
